module.exports = __webpack_public_path__ + "static/media/clear-white-24px.379ce528.svg";